import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  LOADING_CHANGE,
  ON_FORM_CHANGE,
  ON_FLAG_CHANGE,
  SET_ERROR,
} from "../redux/constants";
import { clearFormData, toggleModelShow } from "../shared/CustomFunc";
import { ApiContainer } from "../utils/api";

export const uploadDocumentModalContainer = ({
  pageName,
  endPoint,
  org_id,
  location_id,
  department_id,
  user_id,
  flag,
}) => {
  const { api } = ApiContainer();
  const dispatch = useDispatch();
  const formPath = { parent: "UploadDocumentsData" };
  const { formData, formErrors } = useSelector((state) => state?.form);
  const uploadDocumnetInfo = formData?.UploadDocumentsData ?? {};
  const [highlighted, setHighlighted] = useState(false);
  const loaders = useSelector((state) => ({
    UploadDocumentsLoader: state.api?.loader?.UploadDocumentsData,
  }));
  useEffect(() => () => dispatch(clearFormData(formPath.parent)), []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "file" && files?.[0]) {
      const file = files[0];

      if (file.size > 5 * 1024 * 1024) {
        dispatch({
          type: SET_ERROR,
          payload: {
            formErrors: {
              ...formErrors,
              UploadDocumentsData: {
                ...formErrors?.UploadDocumentsData,
                file: "Please upload PDF files with max size 5 MB.",
              },
            },
          },
        });
        return;
      }
      dispatch({
        type: SET_ERROR,
        payload: {
          formErrors: {
            ...formErrors,
            UploadDocumentsData: {
              ...formErrors?.UploadDocumentsData,
              file: null,
            },
          },
        },
      });
    }

    if (name === "name") {
      dispatch({
        type: SET_ERROR,
        payload: {
          formErrors: {
            ...formErrors,
            UploadDocumentsData: {
              ...formErrors?.UploadDocumentsData,
              name: null,
            },
          },
        },
      });
    }

    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...formData,
          UploadDocumentsData: {
            ...uploadDocumnetInfo,
            [name]: files?.[0] || value,
          },
        },
      },
    });
    if (highlighted) setHighlighted(false);
  };

  const apiCall = async () => {
    dispatch({
      type: LOADING_CHANGE,
      payload: { UploadDocumentsLoader: true },
    });

    const formData = new FormData();
    formData.append("name", uploadDocumnetInfo?.name ?? "");
    formData.append("file", uploadDocumnetInfo?.file);
    formData.append("upload_type", pageName ?? "");
    if (org_id) {
      formData.append("org_id", org_id ?? "");
    }
    if (location_id) {
      formData.append("location_id", location_id ?? "");
    }
    if (department_id) {
      formData.append("department_id", department_id ?? "");
    }
    if (user_id) {
      formData.append("user_id", user_id ?? "");
    }

    const data = await api({
      method: "POST",
      endPoint: endPoint ?? `upload`,
      data: formData,
      showToastMessage: true,
      urlencoded: false,
      parent: "UploadDocumentsData",
      needLoader: true,
      header: { "Content-Type": "multipart/form-data" },
    });

    dispatch({
      type: LOADING_CHANGE,
      payload: { UploadDocumentsLoader: false },
    });
    if (pageName === "document") {
      dispatch({
        type: ON_FLAG_CHANGE,
        payload: { refetchDocumnet: true },
      });
    }

    if (pageName === "waiver") {
      dispatch({
        type: ON_FLAG_CHANGE,
        payload: { refetchWaivers: true },
      });
    }

    if (flag === "expandrow") {
      dispatch(toggleModelShow("uploadWaiversDocumnet"));
    } else {
      dispatch(toggleModelShow("uploadDocumnet"));
    }
  };

  const onUploadDocuments = () => {
    const { name, file } = uploadDocumnetInfo;

    if (!name || !file) {
      dispatch({
        type: SET_ERROR,
        payload: {
          formErrors: {
            ...formErrors,
            UploadDocumentsData: {
              ...formErrors?.UploadDocumentsData,
              name: !name ? "File name is required." : null,
              file: !file ? "File is required." : null,
            },
          },
        },
      });
      return;
    }

    apiCall();
  };

  const onDragEnter = (e) => {
    e.preventDefault();
    setHighlighted(true);
  };

  const onDragLeave = (e) => {
    e.preventDefault();
    setHighlighted(false);
  };

  const onCloseModal = () => {
    if (flag === "expandrow") {
      dispatch(toggleModelShow("uploadWaiversDocumnet"));
    } else {
      dispatch(toggleModelShow("uploadDocumnet"));
    }
    dispatch(clearFormData("UploadDocumentsData"));
  };

  const buttonsContainer = {
    1: [
      { label: "Cancel", handleClick: onCloseModal, variant: "outlined" },
      { label: "Save", handleClick: onUploadDocuments, hasLoader: true },
    ],
  };

  const uploadDocumentsContainer = {
    label: `Upload ${pageName}`,
    data: [
      {
        question: "Enter File Name",
        value: [
          {
            control: "input",
            type: "text",
            name: "name",
            label: "Enter File Name",
            value: "",
            isRequired: true,
            placeholder: "Enter file name",
          },
        ],
        isRequired: true,
      },
      {
        type: "Upload Document",
        question: "Upload PDF File",
        value: [
          {
            control: "input",
            type: "file",
            name: "file",
            value: "",
            placeholder: "Upload your PDF files",
            fullWidth: true,
            isRequired: true,
          },
        ],
      },
    ],
  };

  const handleRemoveFile = () => {
    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...formData,
          UploadDocumentsData: {
            ...uploadDocumnetInfo,
            file: null,
          },
        },
      },
    });
  };

  useEffect(() => {
    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...formData,
          UploadDocumentsData: { ...uploadDocumnetInfo, step: 1 },
        },
      },
    });
    dispatch({ type: ON_FLAG_CHANGE, payload: { fetchLocation: true } });
  }, []);

  return {
    formPath,
    uploadDocumnetInfo,
    handleChange,
    loaders,
    buttonsContainer,
    uploadDocumentsContainer,
    handleRemoveFile,
    highlighted,
    onDragEnter,
    onDragLeave,
  };
};
